<template>
  <div class="margin-header locale-font">
    <TopBar :title="$vuetify.lang.t('$vuetify.leaveRequest.pageName')" />
    <div class="box-round display-height">
      <div class="box-content px-4">
        <v-form lazy-validation ref="form" v-model="valid">
          <div class="row">
            <div class="title-label col-12 line-liff-detail liff-line-font-size-14">
              {{ $vuetify.lang.t("$vuetify.leaveRequest.leaveType.title") }}
            </div>
            <div class="col-12 mt-1 py-0 pb-0">
              <v-select
                :placeholder="$vuetify.lang.t('$vuetify.leaveRequest.leaveType.placeholder')"
                :rules="leaveTypeDDLRule"
                :items="items"
                v-model="leaveTypeDDL"
                class="custom-ddl"
                outlined
              ></v-select>
            </div>
          </div>
          <div class="row mt-7">
            <div class="col-6 pr-1 py-0">
              <div
                @click="changeLeaveType('single')"
                class="radio-button font-weight-bold"
                :class="{ active: leaveType == 'single' }"
              >
                <div class="circle-radio">
                  <div class="full-curcle"></div>
                </div>
                {{ $vuetify.lang.t("$vuetify.leaveRequest.leaveType.single") }}
              </div>
            </div>
            <div class="col-6 pl-1 py-0">
              <div
                @click="changeLeaveType('range')"
                class="radio-button font-weight-bold"
                :class="{ active: leaveType != 'single' }"
              >
                <div class="circle-radio">
                  <div class="full-curcle"></div>
                </div>
                {{ $vuetify.lang.t("$vuetify.leaveRequest.leaveType.range") }}
              </div>
            </div>
          </div>
          <div class="row mt-6">
            <div class="title-label col-12 line-liff-detail liff-line-font-size-14">
              {{ $vuetify.lang.t("$vuetify.leaveRequest.startDate.title") }}
            </div>
            <div class="col-12 py-0 mt-1">
              <CustomDatePicker
                v-model="startDate"
                :placeholder="$vuetify.lang.t('$vuetify.leaveRequest.startDate.placeholder')"
                :rule="dateRule"
                @onChangeDate="onChangeStartDate()"/>
            </div>
          </div>
          <transition name="fade" mode="out-in">
            <div class="row mt-0" v-if="leaveType != 'single'">
              <div class="title-label col-12 line-liff-detail liff-line-font-size-14">
                {{ $vuetify.lang.t("$vuetify.leaveRequest.endDate.title") }}
              </div>
              <div class="col-12 py-0 mt-1 line-liff-detail liff-line-font-size-14">
                <CustomDatePicker
                  v-model="endDate"
                  :placeholder="$vuetify.lang.t('$vuetify.leaveRequest.endDate.title')"
                  :disabledDateFrom="startDate"
                  :rule="dateRule"
                />
              </div>
            </div>
          </transition>
          <div class="row mt-0">
            <div class="title-label col-12 line-liff-detail">
              <span class="liff-line-font-size-14">{{ $vuetify.lang.t("$vuetify.leaveRequest.attachFile.title") }}</span> <span class="liff-line-font-size-12">(.jpg)</span>
            </div>
            <div class="col-12 mt-1 py-0 input_roboto_font">
              <v-text-field
                v-model="fileName"
                :placeholder="$vuetify.lang.t('$vuetify.leaveRequest.attachFile.select')"
                prepend-inner-icon="mdi-folder-upload"
                @click="clickUpload()"
                @click:prepend-inner="clickUpload()"
                outlined
                height="40px"
                :rules="requireImage">
              </v-text-field>
              <input
                ref="file"
                type="file"
                class="no-display hide"
                accept="image/*"
                @change="uploadFile">
            </div>
          </div>
          <div class="row mt-3">
            <div class="title-label col-12 d-flex">
              <div class="col-6 pb-0 px-0 line-liff-detail liff-line-font-size-14">
                {{ $vuetify.lang.t("$vuetify.leaveRequest.reason.title") }}
              </div>
              <div class="col-6 pb-0 px-0 text-right fs-6 line-liff-input-reason liff-line-font-size-10">
                {{ countReason }} / 255
              </div>
            </div>
            <div class="col-12 py-0 mt-1">
              <v-textarea
                class="custom-textarea"
                @input="inputReason()"
                v-model="reason"
                height="100"
                :no-resize="true"
                :rules="reasonRule"
                outlined
                name="input-7-1"
                value=""
                :placeholder="$vuetify.lang.t('$vuetify.leaveRequest.reason.placeholder')"
              ></v-textarea>
            </div>
          </div>
        </v-form>
      </div>
      <div class="box-footer">
        <div class="row mt-5">
          <div class="col-6">
            <ButtonNoBackground
              :title="$vuetify.lang.t('$vuetify.leaveRequest.button.cancel')"
              @clickButton="clickCancel()"/>
          </div>
          <div class="col-6">
            <ButtonFullBackground
              :title="$vuetify.lang.t('$vuetify.leaveRequest.button.submit')"
              @clickButton="clickSubmit()"/>
          </div>
        </div>
      </div>
    </div>
    <ModalSuccess ref="modal-success" @clickOk="onClickConfirm(true)" />
    <ModalFail ref="modal-fail" @clickOk="onClickConfirm(false)"/>
  </div>
</template>
<script>
// lib
import moment from 'moment'

import TopBar from '@/components/Liff/Components/header/TopBar.vue'
import ButtonNoBackground from '@/components/Liff/Components/button/ButtonNoBackground.vue'
import ButtonFullBackground from '@/components/Liff/Components/button/ButtonFullBackground.vue'
import CustomDatePicker from '@/components/Liff/Components/Input/CustomDatePicker.vue'
import ModalSuccess from '@/components/Liff/Modals/ModalSuccess.vue'
import ModalFail from '@/components/Liff/Modals/ModalFail.vue'

export default {
    name: 'LeaveRequest',
    components: {
        TopBar,
        ButtonFullBackground,
        ButtonNoBackground,
        CustomDatePicker,
        ModalSuccess,
        ModalFail
    },
    data: function () {
        return {
            valid: false,
            lineUserId: null,
            lineLiffId: process.env.VUE_APP_LINE_LIFF_LEAVE_REQUEST,
            leaveTypeDDL: null,
            startDate: moment().format('YYYY-MM-DD'),
            endDate: null,
            items: [],
            fileName: null,
            fileBase64: null,
            countReason: 0,
            reason: null,
            leaveType: 'single',
            options: [],
            leaveTypeDDLRule: [
                v => !!v || this.$vuetify.lang.t('$vuetify.leaveRequest.leaveType.require')
            ],
            dateRule: [
                v => !!v || this.$vuetify.lang.t('$vuetify.leaveRequest.endDate.require')
            ],
            requireImage: [
                v => !!v || this.$vuetify.lang.t('$vuetify.leaveRequest.uploadYourPhoto')
            ],
            reasonRule: [
                v => (v && v.length <= 255) || this.$vuetify.lang.t('$vuetify.leaveRequest.reason.invalid'),
                v => !!v || this.$vuetify.lang.t('$vuetify.leaveRequest.reason.require')
            ]
        }
    },
    mounted: function () {
        this.initialData()
    },
    methods: {
        initialData: async function () {
            this.$store.dispatch('setLoading', true)
            try {
                const lineUserId = await this.$liffUtil.getLineIdForLiff(this.lineLiffId)
                this.lineUserId = lineUserId
                const res = await this.axios.get('inquiry/type/options')
                this.items = res.data.data
                this.leaveTypeDDL = res.data.data[0].value
            } catch {
            }
            this.$store.dispatch('setLoading', false)
        },
        onChangeStartDate: function () {
            this.endDate = ''
        },
        changeLeaveType: function (leaveType) {
            this.leaveType = leaveType
        },
        onClickConfirm: function (isCloseLine) {
            this.$refs.form.resetValidation()
            this.lineUserId = null
            this.leaveTypeDDL = null
            this.startDate = moment().format('YYYY-MM-DD')
            this.endDate = null
            this.fileBase64 = null
            this.reason = null
            if (isCloseLine) this.clickCancel()
        },
        clickSubmit: async function () {
            const isValidate = this.$refs.form.validate()
            if (isValidate) {
                let isValid = true
                if (!this.reason || (this.reason && this.reason.length > 250)) isValid = false
                if (this.leaveType !== 'single' && !this.endDate) isValid = false
                if (!this.leaveTypeDDL) isValid = false

                if (isValid) {
                    this.$store.dispatch('setLoading', true)
                    const params = this.getParams()

                    const res = await this.axios.post('inquiry/submit', params)
                    if (res && res.data && res.data.status === 'ok') {
                        this.openModalSuccess('ok')
                    } else {
                        this.openModalFail(res.data.msg)
                    }

                    this.$store.dispatch('setLoading', false)
                }
            }
        },
        clickCancel: function () {
            this.$liffUtil.closeWindow(this.lineLiffId)
        },
        clickUpload: function () {
            this.$refs.file.click()
        },
        uploadFile: async function (e) {
            if (e.target.files.length > 0) {
                const file = e.target.files[0]
                const sizeInMB = file.size / (1000 * 1000)
                if (sizeInMB > 100) {
                    const body = this.$vuetify.lang.t('$vuetify.VisitorCreate.uploadIdCard.placeholder')
                    this.openModalFail(body)
                } else {
                    this.fileName = file.name
                    this.fileBase64 = await this.$imageUtil.getBase64(file)
                }
                this.$refs.file.value = ''
            }
        },
        inputReason: function () {
            this.countReason = this.reason.length
        },
        getParams: function () {
            const params = {
                lineId: this.lineUserId,
                inquiryType: this.leaveTypeDDL,
                startDate: this.startDate,
                endDate: this.endDate,
                attachment: this.fileBase64,
                detail: this.reason
            }
            return params
        },
        openModalSuccess: function () {
            const title = this.$vuetify.lang.t('$vuetify.leaveRequest.modalSuccess.title')
            const btnOk = this.$vuetify.lang.t('$vuetify.leaveRequest.modalSuccess.btnOk')
            const body = this.$vuetify.lang.t('$vuetify.leaveRequest.modalSuccess.body')
            const params = {
                title: title,
                btnOk: btnOk,
                body: body
            }
            this.$refs['modal-success'].show(params)
        },
        openModalFail: function (text) {
            const title = this.$vuetify.lang.t('$vuetify.leaveRequest.modalFail.title')
            const btnOk = this.$vuetify.lang.t('$vuetify.leaveRequest.modalFail.btnOk')
            const params = {
                title: title,
                btnOk: btnOk,
                body: text
            }
            this.$refs['modal-fail'].show(params)
        }
    }
}
</script>
<style lang="scss" scoped>
  @import "@/styles/color.scss";
  .font-information {
      font-size: 14px;
      color: #a8a8a8;
  }
  ::v-deep .v-text-field--outlined > .v-input__control > .v-input__slot {
      min-height: 40px;
  }
  ::v-deep .v-messages__message {
    font-family: Prompt;
  }
  ::v-deep .v-icon.v-icon.v-icon--link {
      cursor: pointer;
      outline: none;
      padding-bottom: 20px;
  }
</style>
